const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpquestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4999"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6651",
    d: "M9 0a9 9 0 1 0 9 9 8.995 8.995 0 0 0-9-9zm-.266 13.212a.912.912 0 0 1 0-1.824.912.912 0 0 1 0 1.824zm1.35-4.612a1.488 1.488 0 0 0-.663 1.481c0 .225-.118.486-.7.486-.486 0-.652-.178-.652-.794a2.169 2.169 0 0 1 .794-1.8c.391-.332 1.054-.7 1.054-1.339 0-.545-.474-.806-1.066-.806-1.208 0-.948.912-1.587.912a.679.679 0 0 1-.711-.675c0-.64.734-1.587 2.334-1.587 1.516 0 2.523.841 2.523 1.955A3.032 3.032 0 0 1 10.084 8.6z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpquestion);
export default __webpack_public_path__ + "static/media/helpquestion.10aa87f6c711bc32bfa0803a1f83abea.svg";
export { ForwardRef as ReactComponent };